import React from "react";
import { ContentProps } from "./types";
import { useFeedbackWorkflow } from "./FeedbackWorkflowContext";
import { cross, thanksPopUpTick } from "../../../../components/FeedbackOverview/SVG";
import QuestLabs from "../../../../components/QuestLabs";

const ThankYou: React.FC<ContentProps> = () => {
    const {
        submit,
        handleBackClick,
        handleThanks,
    } = useFeedbackWorkflow();

    const { themeManager, feedbackWorkflowFunctions } = useFeedbackWorkflow();

    return (
        <>
            {submit && (
                <div
                    className="q-fw-div"
                    style={{
                        ...themeManager?.getThanksPopUpBackgroundStyles()
                    }}
                    id="disabledClick"
                >
                    <div className="q_submit_cross_icon" onClick={handleThanks}>
                        {cross(feedbackWorkflowFunctions.geticonColor(), handleBackClick)}
                    </div>
                    <div className="q-fw-thanks">
                        <div>
                            <div className="q-svg-thanks">
                                {thanksPopUpTick(
                                    themeManager.getThanksPopUbIconBackgroundStyle()
                                )}
                            </div>
                            <div className="q_fw_submit_box">
                                <div className="q_feedback_text_submitted">
                                    <div
                                        className="q_feedback_text_cont"
                                        style={{
                                            ...themeManager.getThanksPopUpHeadingStyle()
                                        }}
                                    >
                                        Feedback Submitted
                                    </div>
                                    <div
                                        className="q_fw_submit_desc"
                                        style={{
                                            ...themeManager.getThanksPopUpDescriptionStyle()
                                        }}
                                    >
                                        Thanks for submitting your feedback with us. We
                                        appreciate your review and will assure you to surely
                                        consider them
                                    </div>
                                </div>
                                <div
                                    className="q_fw_submit_back"
                                    style={{
                                        ...themeManager.getThanksPopUpSecondaryBtnBackground()
                                    }}
                                >
                                    {feedbackWorkflowFunctions.getSecondaryButtonText()}
                                </div>
                            </div>
                        </div>
                    </div>
                    {(themeManager.getThanksPopUpFooter() || feedbackWorkflowFunctions.getshowFooter()) && (
                        <QuestLabs
                            style={themeManager?.getFooterStyles()?.FooterStyle}
                            textStyle={themeManager?.getFooterStyles()?.FooterTextStyle}
                            iconStyle={themeManager?.getFooterStyles()?.FooterIcon}
                            text={themeManager?.getFooterStyles()?.FooterText}
                            link={themeManager?.getFooterStyles()?.FooterLink}
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default ThankYou;
